import React from 'react';
import { connect } from 'react-redux';
import { FormElement, TextAreaInput, TimeInput, DateInput, Button, Icon } from 'b3';
import Select from 'b3/select/Select';
import moment from 'moment-timezone';
import StaffMemberPicker from '../../components/StaffMemberPicker';
import { goToStep, completeWizard, goToFollowUpCallStep, updateScheduledMeetingData, saveStackedStepAndGoBack } from './logActivityReducer';

@connect(
    state => ({
        isSaving: state.logActivityWizard.isSaving,
        client: state.activeClient.client,
        scheduledMeetingData: state.logActivityWizard.scheduledMeetingData,
        activeScheduledMeetingIndex: state.logActivityWizard.activeScheduledMeetingIndex,
        users: state.users.users
    }),
    { goToStep, completeWizard, goToFollowUpCallStep, updateScheduledMeetingData, saveStackedStepAndGoBack }
)
export default class BookMeetingStep extends React.Component {
    componentDidMount() {
        this.textInput.focus();
    }
    updateDate = (date) => {
        this.props.updateScheduledMeetingData({date});
    }
    updateDescription(description) {
        this.props.updateScheduledMeetingData({description});   
    }
    onUserSelected = (assignedEmployeeIds) => {
        this.props.updateScheduledMeetingData({assignedEmployeeIds});
    }
    handleLocationSelected({value}) {
        this.props.updateScheduledMeetingData({location: value});
    }
    handleMeetingTypeSelected({value}) {
        this.props.updateScheduledMeetingData({meetingType: value});
    }
    render() {
        var { scheduledMeetingData, client, completeWizard, users, isInStackedStep, saveStackedStepAndGoBack, activeScheduledMeetingIndex } = this.props;
        var { meetingType, location, date, description, assignedEmployeeIds = [] } = scheduledMeetingData[activeScheduledMeetingIndex];

        var locations = ['web', 'at office', 'off site'];
        var meetingTypes = ['demo', 'training'];

        var locationOptions = locations.map(l => ({
            name: l.capitalise(),
            value: l
        }));

        var selectedLocation = locationOptions.find(l => l.value == location);

        var locationOptions = locations.map(l => ({
            name: l.capitalise(),
            value: l
        }));
        
        var meetingTypeOptions = meetingTypes.map(m => ({
            name: m.capitalise(),
            value: m
        }));

        var selectedMeetingType = meetingTypeOptions.find(m => m.value == meetingType);

        var selectedUsers = users.filter(user => assignedEmployeeIds.includes(user.id))

        return (
            <div className="wizard-step-wrapper">
                <h1>Book meeting</h1>
                <div className="schedule-date-time-picker">
                    <div>
                        <h2>Time</h2>
                        <FormElement icon="clock-2">
                            <TimeInput
                                value={date}
                                onChange={this.updateDate}
                            />
                        </FormElement>
                    </div>
                    <div>
                        <h2>Date</h2>
                        <FormElement icon="calendar-2" style={{width: 160}}>
                            <DateInput
                                submitOnChangeOnly={true}
                                value={date}
                                onChange={this.updateDate}
                            />
                        </FormElement>
                    </div>
                    <div>
                        <h2>Type</h2>
                        <div className="select-wrapper">
                            <Select
                                placeholder="Select type"
                                size={16}
                                canFilter={false} 
                                canDeselect={false} 
                                template={o => o.name} 
                                options={meetingTypeOptions} 
                                onOptionSelected={this.handleMeetingTypeSelected.bind(this)} 
                                selectedOption={selectedMeetingType} />
                        </div>
                    </div>
                </div>
                <div className="schedule-meeting-assignment-location">
                    <div style={{flex: 1}}>
                        <h2>
                            Assigned Employee
                        </h2>
                        <StaffMemberPicker 
                            onSelectChange={this.onUserSelected}
                            includeAvatarPicker={false}
                            assignedUserIds={assignedEmployeeIds} 
                            callersOnly={true} />
                    </div>
                    <div>
                        <h2>Location</h2>
                        <div className="select-wrapper">
                            <Select
                                placeholder="Select location"
                                canFilter={false} 
                                canDeselect={false} 
                                template={o => o.name} 
                                options={locationOptions} 
                                onOptionSelected={this.handleLocationSelected.bind(this)} 
                                selectedOption={selectedLocation} />
                        </div>
                    </div>
                </div>
                <div className="form-row">
                    <h2>
                        Agenda
                    </h2>
                    <div>
                        <TextAreaInput
                            ref={el => this.textInput = el}
                            rows={3}
                            placeholder="Enter the agenda for the next call"
                            value={description} 
                            onChange={this.updateDescription.bind(this)} />
                    </div>
                </div>
                <div className="time-conversion-wrapper">
                    <div className="w-row">
                        <Icon icon="clock-2" size={14} />
                        <strong>Your time</strong>
                        <span>{moment(date).format('hh:mm a')}</span>
                    </div>
                    <div className="w-row">
                        <strong>Client's time</strong>
                        {client.timezone &&
                            <span>{moment(date).tz(client.timezone).format('hh:mm a')} ({client.timezone})</span>
                        }
                        {!client.timezone &&
                            <span>n/a</span>
                        }
                    </div>
                    <div className="w-row">
                        {selectedUsers.map(u =>
                            <div key={u.id}>
                                <strong>{u.firstName} {u.lastName}</strong>
                                {u.timezone &&
                                    <span>{moment(date).tz(u.timezone).format('hh:mm a')} ({u.timezone})</span>
                                }
                                {!u.timezone &&
                                    <span>n/a</span>
                                }
                            </div>
                        )}
                    </div>
                </div>
                <div className="save-and-back-or-complete-wrapper">
                    {isInStackedStep &&
                        <Button
                            type="success"
                            onClick={saveStackedStepAndGoBack}
                        >
                            Save and go back
                        </Button>
                    }
                    <Button
                        type="primary"
                        onClick={completeWizard}
                    >
                        Complete
                    </Button>
                </div>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./app/components/schedule-wizard/BookMeetingStep.js